import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import Spinner from 'shared/components/Spinner';
import { Submit } from 'shared/components/Form';
import styles from './Columns.module.scss';

const NavigationColumn = forwardRef(({
  children,
  className,
  collapseOnMobile,
  isMobileView,
  isHidden,
  isFilterOpened,
  onFilterToggle,
  loading
}, ref) => {
  const { t } = useTranslation('userportal');

  const hasContent = React.Children.count(children) > 0;

  return (
    <aside className={cn('col-xl-3 col-lg-4 col-md-12', styles.navigation, className)}>
      {loading && <Spinner splash top />}
      <div
        ref={ref}
        className={cn({ [styles.wrapper]: collapseOnMobile, [styles.closed]: isFilterOpened === false })}
      >
        {children}
      </div>
      {isMobileView && collapseOnMobile && hasContent && !isHidden && (
        <>
          <Submit
            fullWidth
            iconClassName="la la-sliders-h"
            title={t('navigation.openFilter')}
            onClick={onFilterToggle}
          />
        </>
      )}
    </aside>
  );
});

NavigationColumn.displayName = 'forwardRef(NavigationColumn)';

NavigationColumn.propTypes = {
  className: PropTypes.string,
  collapseOnMobile: PropTypes.bool,
  isFilterOpened: PropTypes.bool,
  onFilterToggle: PropTypes.func,
  loading: PropTypes.bool,
  isMobileView: PropTypes.bool,
  isHidden: PropTypes.bool,
};

NavigationColumn.defaultProps = {
  className: '',
  collapseOnMobile: false,
  isFilterOpened: false,
  onFilterToggle() {},
  loading: false,
  isMobileView: false,
  isHidden: false,
};

export default NavigationColumn;
